/**
 * Styled Components - Created by cazarez on 08/02/18.
 */
import styled from 'styled-components'
interface StyleProps {
  priceColor?: string
  fromDetails?: boolean
}
export const Container = styled.div``

export const Text = styled.div`
  color: #fff;
`
export const AvailablePrices = styled.div`
  margin-right: 20px;

  @media (min-width: 320px) and (max-width: 480px) {
    margin-right: 5px;
  }
`

export const PriceLabel = styled.div`
  color: ${({ priceColor }: StyleProps) => priceColor ? priceColor : '#5f6062'};
  font-size: 14px;
  font-weight: 600;
  line-height: 25px;

  @media (min-width: 320px) and (max-width: 768px) {
    font-size: ${({ fromDetails }: StyleProps) => fromDetails ? '14px' : '16px'};
    line-height: ${({ fromDetails }: StyleProps) => fromDetails ? '1.5' : '25px'};
  }
`
export const QuantityLabel = styled.div`
  color: #5f6062;
  font-size: 11px;
  line-height: 16px;
`

export const BottomLabels = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 1080px) {
    flex-wrap: wrap;
  }
`

export const Margin = styled.div`
  margin-left: 6px;
  background: #ffe7cb;
  padding: 0 4px;
  border-radius: 3px;
  font-size: 10px;
  line-height: 16px;
  @media (max-width: 768px) {
    margin-left: 0px;
    margin-top: 2px;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/PriceQuantity/styledComponents.tsx